<template>
  <div v-if="false" />
</template>

<script>
export default {
  inject: ['$mapPromise'],
  emits: ['map'],
  async created() {
    const map = await this.$mapPromise;
    this.$emit('map', map);
  },
};
</script>
